// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1fxC2","label":"CategoryService_label__3LsGZ","location":"CategoryService_location__4kOup"};